import { createContext, useContext, useState } from "react";

interface CreateMaterialDialogContexProps {
  isCreateModalOpen: boolean;
  setIsCreateModalOpen: (value: boolean) => void;
}

const CreateMaterialDialogContext = createContext({
  isCreateModalOpen: false,
  setIsCreateModalOpen: () => {},
} as CreateMaterialDialogContexProps);

export const CreateMaterialDialogProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);

  return (
    <CreateMaterialDialogContext.Provider
      value={{
        isCreateModalOpen,
        setIsCreateModalOpen,
      }}
    >
      {children}
    </CreateMaterialDialogContext.Provider>
  );
};

export const useCreateMaterialDialog = () => {
  const context = useContext(CreateMaterialDialogContext);

  if (!context) {
    throw new Error(
      "useCreateMaterialDialog must be used within an CreateMaterialDialogProvider",
    );
  }

  return context;
};
